import React, { ReactNode } from 'react';
import styles from './assets/deduction-screen.module.scss';
import classNames from 'classnames';
import DeductionsGrid from './components/DeductionsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IDeduction } from 'src/types/deduction';

export interface StateProps {
    data: Paginated<IDeduction>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class DeductionsList extends React.Component<Props> {
    //componentDidMount() {}

    public render(): ReactNode {
        const { data, getData } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>
                        DEDUCTIONS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    <DeductionsGrid data={data} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default DeductionsList;
